export enum LIQUID_NET_WORTH {
  RANGE_5K_OR_BELOW = "RANGE_5K_OR_BELOW",
  RANGE_5K_TO_25K = "RANGE_5K_TO_25K",
  RANGE_25K_TO_50K = "RANGE_25K_TO_50K",
  RANGE_50K_TO_100K = "RANGE_50K_TO_100K",
  RANGE_100K_TO_250K = "RANGE_100K_TO_250K",
  RANGE_250K_TO_500K = "RANGE_250K_TO_500K",
  RANGE_500K_TO_1M = "RANGE_500K_TO_1M",
  RANGE_1M_AND_ABOVE = "RANGE_1M_AND_ABOVE"
}

export enum ANNUAL_INCOME {
  RANGE_25K_OR_BELOW = 'RANGE_25K_OR_BELOW',
  RANGE_25K_TO_50K = "RANGE_25K_TO_50K",
  RANGE_50K_TO_100K = "RANGE_50K_TO_100K",
  RANGE_100K_TO_200K = "RANGE_100K_TO_200K",
  RANGE_200K_TO_500K = "RANGE_200K_TO_500K",
  RANGE_500K_AND_ABOVE = "RANGE_500K_AND_ABOVE"
}

export enum INVESTMENT_OBJECTIVE {
  PRESERVE = "PRESERVE",
  BALANCE = "BALANCE",
  GROW = "GROW"
}

export enum RISK_LEVEL {
  LOWEST = "LOWEST",
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  HIGH = "HIGH",
  HIGHEST = "HIGHEST"
}